import { SolanaWithSignerBaseCommand } from '../../../../solana';

import { web3 } from '@coral-xyz/anchor';
import { Args, Flags } from '@oclif/core';
import { Queue } from '@switchboard-xyz/on-demand';

export default class QueueAllowSubsidy extends SolanaWithSignerBaseCommand {
  static enableJsonFlag = true;

  static description = 'Allow or disallow subsidy for a queue';

  static flags = {
    ...SolanaWithSignerBaseCommand.flags,
    enable: Flags.boolean({
      description: 'enable the subsidy',
      required: true,
    }),
  };

  static args = {
    queue: Args.string({
      description: 'The queue account to configure',
    }),
  };

  async run() {
    const { args, flags } = await this.parse(
      this.constructor as typeof QueueAllowSubsidy
    );

    const program = await this.program;

    const queue = new Queue(program, new web3.PublicKey(args.queue!));
    const enable = flags.enable ?? false;
    const ix = await queue.allowSubsidyIx({ enable });

    await this.signAndSend([ix]);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async catch(error: any) {
    super.catch(error, 'failed to configure queue account');
  }
}
